import { MatchState, Player } from '../types';
import { getGameballStatus, getMatchballStatus } from '../utils';

/**
 * Hook contenant la logique réutilisable pour les règles du match
 */
export function useMatchLogic(matchState: MatchState) {
  
  // Détermine si un joueur peut sélectionner le côté de service
  // Le serveur peut toujours changer de côté (même après le 1er point)
  const canSelectSide = (player: Player): boolean => {
    return matchState.servingPlayer === player;
  };
  
  // Détermine si un joueur peut scorer
  // Les deux joueurs peuvent toujours scorer (serveur et receveur)
  const canScore = (player?: Player): boolean => {
    return true;
  };

  // Détermine si on peut prendre une décision (LET, STROKE, NOLET)
  const canMakeDecision = (): boolean => {
    return true;
  };
  
  // Obtient le statut Game ball pour un joueur
  const getPlayerGameballStatus = (player: Player): boolean => {
    return getGameballStatus(player, matchState.gameScores);
  };
  
  // Obtient le statut Match ball pour un joueur
  const getPlayerMatchballStatus = (player: Player): boolean => {
    return getMatchballStatus(
      player, 
      matchState.gameScores, 
      matchState.setScores, 
      matchState.matchInfo.scoringType
    );
  };
  
  // Obtient le nom d'un joueur selon son ID
  const getPlayerName = (player: Player): string => {
    return player === 'A' ? matchState.matchInfo.playerA : matchState.matchInfo.playerB;
  };
  
  // Obtient la couleur d'un joueur
  const getPlayerColor = (player: Player): string => {
    return player === 'A' ? matchState.playerAColor : matchState.playerBColor;
  };
  
  return {
    canSelectSide,
    canScore,
    canMakeDecision,
    getPlayerGameballStatus,
    getPlayerMatchballStatus,
    getPlayerName,
    getPlayerColor
  };
}